import ApiService from "./apiservice";

export const LockService = {
    CheckHaveAccessToMobkart() {
        return ApiService.get("lock/CheckHaveAccessToMobkart");
    },
    GetCustomerName() {
        debugger
        return ApiService.get("GetCustomerName");
    },
    hasActiveDirectory() {
        return ApiService.get("lock/hasActiveDirectory");
    },
    IsValidDomainLoginName(params) {
        return ApiService.get("IsValidDomainLoginName",params);
    },
    IsLockActive() {
        return ApiService.get("IsLockActive");
    },
    GetLockData() {
        return ApiService.get("GetLockData");
    },
};